import React, { useCallback, useEffect, useMemo, useState } from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

Modal.setAppElement("#root");

const flyerPdfHref = "/Prilozi/DOM UČENIKA FLAJER.pdf";

const flyerImages = [
  { src: "assets/img/bg/DOM UČENIKA FLAJER-1.webp" },
  { src: "assets/img/bg/DOM UČENIKA FLAJER-2.webp" },
];

function DomStudentata() {
  const { t, i18n } = useTranslation();
  const isEN = (i18n?.language || "").toLowerCase().startsWith("en");

  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const bullets = useMemo(
    () => [
      "dom.l1",
      "dom.l2",
      "dom.l3",
      "dom.l4",
      "dom.l5",
      "dom.l6",
      "dom.l7",
      "dom.l8",
      "dom.l9",
    ],
    [],
  );

  // Ikone su “vizuelni sloj” - tekst ostaje 1/1 iz JSON-a.
  const bulletIcons = useMemo(
    () => [
      "fa-hands-helping",
      "fa-info-circle",
      "fa-comments",
      "fa-running",
      "fa-lightbulb",
      "fa-shield-alt",
      "fa-project-diagram",
      "fa-globe",
      "fa-seedling",
    ],
    [],
  );

  const openModal = useCallback((index) => {
    setActiveIndex(index);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => setIsOpen(false), []);

  const next = useCallback(() => {
    setActiveIndex((i) => (i + 1) % flyerImages.length);
  }, []);

  const prev = useCallback(() => {
    setActiveIndex((i) => (i - 1 + flyerImages.length) % flyerImages.length);
  }, []);

  // Scroll lock (sa cleanup-om)
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const encodedPdfHref = useMemo(() => encodeURI(flyerPdfHref), []);
  const activeFlyerSrc = useMemo(
    () => encodeURI(flyerImages[activeIndex]?.src || ""),
    [activeIndex],
  );

  return (
    <>
      <Navbar />

      <Bredcom title={isEN ? "Home" : "Početna"} subtitle={t("studenti.dom")} />

      <div className="container mt-4 pt-40 dorm-page">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container pb-60 textjustify dorm-page__content">
              {/* HERO */}
              <section className="dorm-hero" aria-labelledby="dorm-hero-title">
                <div className="dorm-hero__eyebrow">
                  <i className="fas fa-building" aria-hidden="true" />
                  <span>
                    {t("dom.heroEyebrow", {
                      defaultValue: isEN
                        ? "Student support"
                        : "Studentska podrška",
                    })}
                  </span>
                </div>

                <h1 id="dorm-hero-title" className="dorm-hero__title">
                  {t("dom.title")}
                </h1>

                <p className="dorm-hero__lead">
                  {t("dom.heroLead", {
                    defaultValue: isEN
                      ? "Accommodation information and a flyer with details (PDF)."
                      : "Informacije o smještaju i flajer sa detaljima (PDF).",
                  })}
                </p>

                <div className="dorm-hero__actions" aria-label="Actions">
                  <a
                    className="btn dorm-btn dorm-btn--primary"
                    href={encodedPdfHref}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fas fa-file-pdf" aria-hidden="true" />
                    {t("dom.ctaFlyer", {
                      defaultValue: isEN
                        ? "Download flyer (PDF)"
                        : "Preuzmi flajer (PDF)",
                    })}
                  </a>

                  <a
                    className="btn dorm-btn dorm-btn--ghost"
                    href="#dorm-flyer"
                  >
                    <i className="fas fa-images" aria-hidden="true" />
                    {t("dom.ctaGallery", {
                      defaultValue: isEN ? "View flyer" : "Pogledaj flajer",
                    })}
                  </a>
                </div>
              </section>

              {/* TEKST (NE MIJENJA SE) */}
              <section
                className="dorm-section"
                aria-labelledby="dorm-about-title"
              >
                <h2 id="dorm-about-title" className="dorm-section__title">
                  {t("dom.aboutTitle", {
                    defaultValue: isEN ? "About the dormitory" : "O domu",
                  })}
                </h2>

                <div className="dorm-card dorm-card--article">
                  <div
                    className="dorm-card__icon dorm-card__icon--article"
                    aria-hidden="true"
                  >
                    <i className="fas fa-bed" />
                  </div>
                  <div className="dorm-card__body">
                    <p className="dorm-card__text">{t("dom.p1")}</p>
                    <p className="dorm-card__text">{t("dom.p2")}</p>
                    <p className="dorm-card__text dorm-card__text--last">
                      {t("dom.p3")}
                    </p>
                  </div>
                </div>
              </section>

              {/* FOKUS + LISTA (NE MIJENJA SE) */}
              <section
                className="dorm-section"
                aria-labelledby="dorm-focus-title"
              >
                <h2 id="dorm-focus-title" className="dorm-section__title">
                  {t("dom.focusTitle", {
                    defaultValue: isEN
                      ? "Focus of joint activities"
                      : "Fokus zajedničkog djelovanja",
                  })}
                </h2>

                <p className="dorm-section__lead">{t("dom.p4")}</p>

                <div className="row dorm-bullets">
                  {bullets.map((key, idx) => (
                    <div className="col-lg-6" key={key}>
                      <article className="dorm-card dorm-card--bullet">
                        <div className="dorm-card__icon" aria-hidden="true">
                          <i
                            className={`fas ${bulletIcons[idx] || "fa-check-circle"}`}
                          />
                        </div>
                        <div className="dorm-card__body">
                          <p className="dorm-card__text dorm-card__text--bullet">
                            {t(key)}
                          </p>
                        </div>
                      </article>
                    </div>
                  ))}
                </div>
              </section>

              {/* FLYER */}
              <section
                className="dorm-section"
                id="dorm-flyer"
                aria-labelledby="dorm-flyer-title"
              >
                <div className="dorm-flyerHead">
                  <h2 id="dorm-flyer-title" className="dorm-section__title">
                    {t("dom.flyerTitle", {
                      defaultValue: isEN ? "Flyer" : "Flajer",
                    })}
                  </h2>

                  <p className="dorm-section__lead">
                    {t("dom.flyerLead", {
                      defaultValue: isEN
                        ? "Click an image to open it in full size."
                        : "Klikni na sliku za prikaz u punoj veličini.",
                    })}
                  </p>
                </div>

                <div className="dorm-flyerCta">
                  <a
                    className="dorm-flyerLink"
                    href={encodedPdfHref}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <strong>
                      {t("dom.flyerLinkLabel", {
                        defaultValue: "DOM UČENIKA FLAJER",
                      })}
                    </strong>
                    <i
                      className="fas fa-external-link-alt"
                      aria-hidden="true"
                    />
                  </a>
                </div>

                <div className="row dorm-flyerGrid">
                  {flyerImages.map((img, index) => {
                    const src = encodeURI(img.src);
                    return (
                      <div className="col-md-6" key={img.src}>
                        <button
                          type="button"
                          className="dorm-flyerThumb"
                          onClick={() => openModal(index)}
                        >
                          <img
                            src={src}
                            alt={
                              isEN
                                ? `Flyer page ${index + 1}`
                                : `Flajer strana ${index + 1}`
                            }
                            loading="lazy"
                            decoding="async"
                          />
                          <span
                            className="dorm-flyerThumb__overlay"
                            aria-hidden="true"
                          >
                            <i className="fas fa-search-plus" />
                            {t("dom.openPreview", {
                              defaultValue: isEN ? "Open" : "Otvori",
                            })}
                          </span>
                        </button>
                      </div>
                    );
                  })}
                </div>
              </section>

              {/* MODAL */}
              <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                shouldCloseOnOverlayClick
                shouldCloseOnEsc
                className="dorm-modal"
                overlayClassName="dorm-modal__overlay"
                contentLabel={isEN ? "Flyer preview" : "Pregled flajera"}
              >
                <div className="dorm-modal__top">
                  <button
                    type="button"
                    onClick={closeModal}
                    className="dorm-modal__close"
                    aria-label={t("dom.modalClose", {
                      defaultValue: isEN ? "Close" : "Zatvori",
                    })}
                  >
                    <i className="fas fa-times" aria-hidden="true" />
                  </button>
                </div>

                <div className="dorm-modal__body">
                  <button
                    type="button"
                    className="dorm-modal__nav dorm-modal__nav--prev"
                    onClick={prev}
                    aria-label={t("dom.modalPrev", {
                      defaultValue: isEN ? "Previous page" : "Prethodna strana",
                    })}
                  >
                    <i className="fas fa-chevron-left" aria-hidden="true" />
                  </button>

                  <img
                    className="dorm-modal__img"
                    src={activeFlyerSrc}
                    alt=""
                  />

                  <button
                    type="button"
                    className="dorm-modal__nav dorm-modal__nav--next"
                    onClick={next}
                    aria-label={t("dom.modalNext", {
                      defaultValue: isEN ? "Next page" : "Sljedeća strana",
                    })}
                  >
                    <i className="fas fa-chevron-right" aria-hidden="true" />
                  </button>
                </div>

                <div className="dorm-modal__footer">
                  {t("dom.modalCounter", {
                    defaultValue: isEN
                      ? "Page {{page}} of {{total}}"
                      : "Strana {{page}} od {{total}}",
                    page: activeIndex + 1,
                    total: flyerImages.length,
                  })}
                </div>
              </Modal>
            </div>
          </div>

          {/* SIDEBAR: ostaje kao kod tebe */}
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">{t("sidebar.follow")}</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Facebook"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Instagram"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>

              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">{t("sidebar.useful")}</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">{t("about.fpep")}</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">
                      {t("admission.Akreditacija")}
                    </Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">{t("upis.title")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">{t("admission.Skolarina")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">{t("saradnja.projekti")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">{t("navbar.Gallery")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">{t("navbar.News")}</Link>
                  </li>
                </ul>
              </section>

              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">{t("sidebar.study")}</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.osnovne")}</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      {t("osnovne.rfb")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      {t("osnovne.menadzment")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      {t("osnovne.pravo")}
                      <br />
                    </Link>
                  </li>

                  <li>
                    <span className="post-date">
                      <strong>{t("programs.master")}</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      {t("master.poslovnaEkonomija")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      {t("master.ekonomijaJavnogSektora")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      {t("master.pravo")}
                      <br />
                    </Link>
                  </li>

                  <li>
                    <span className="post-date">
                      <strong>{t("programs.specijalisticke")}</strong> <br />
                    </span>
                    <Link to="/menadzment-javnog-sektora-specijalisticke">
                      {t("specijalisticke.mjs")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment-profitnog-sektora-specijalisticke">
                      {t("specijalisticke.mps")}
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default DomStudentata;
